import { Component } from '@angular/core';
import { FileUploadService } from '../file-upload.service';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss']
})

export class FileUploadComponent {
    loading: boolean = false; // Flag variable
    error: string;
  
    // Inject service 
    constructor(
        private fileUploadService: FileUploadService,
    ) {}
  
    // On file Select
    upload(event) {
        if ( event.target.files.length === 1 ) {
            let [file] = event.target.files;

            if (file.type.indexOf('image/') === -1) {
                this.error = "This file type is not accepted."
                return
            }

            if (file.size > 5000000) {
                this.error = "This file size is larger than 5MB. Please reduce the size of this image."
                return
            }

            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                this.fileUploadService.image = reader.result as string;
            };

            // save image to service or make form selector
            this.fileUploadService.file = file;
            this.fileUploadService.dirty = true;
        }
    }

    clear() {
        this.fileUploadService.file = null;
        this.fileUploadService.image = null;
        this.fileUploadService.dirty = true;
    }

    get file(){
        return this.fileUploadService.file;
    }

    get image(){
        return this.fileUploadService.image;
    }
}